import {HTTP_INTERCEPTORS} from "@angular/common/http";
import {EnvironmentProviders, inject, makeEnvironmentProviders, provideAppInitializer} from "@angular/core";
import {
    MSAL_INSTANCE,
    MSAL_INTERCEPTOR_CONFIG,
    MsalBroadcastService,
    MsalInterceptor,
    MsalInterceptorConfiguration,
    MsalService,
} from "@azure/msal-angular";
import {InteractionType, IPublicClientApplication, LogLevel, PublicClientApplication} from "@azure/msal-browser";
import {Configuration} from "@menu-api";
import {environment} from "@menu-environment";
import {SecurityService} from "@menu-security";

function MSALInstanceFactory(): IPublicClientApplication {
    return new PublicClientApplication({
        auth: {
            clientId: environment.azure.appId,
            authority: `https://login.microsoftonline.com/${environment.azure.tenantId}`,
            redirectUri: "/",
            postLogoutRedirectUri: "/",
        },
        cache: {
            cacheLocation: "localStorage",
        },
        system: {
            allowPlatformBroker: false,
            loggerOptions: {
                logLevel: LogLevel.Info,
                piiLoggingEnabled: false,
            },
        },
    });
}

function MSALInterceptorConfigFactory(): MsalInterceptorConfiguration {
    return {
        interactionType: InteractionType.Redirect,
        protectedResourceMap: new Map<string, string[]>(
            [[`${environment.apiBasePath}/*`, [`${environment.azure.appId}/.default`]]],
        ),
    };
}

export const provideSecurity: () => EnvironmentProviders = () => makeEnvironmentProviders([
    {
        provide: Configuration,
        useValue: new Configuration({basePath: environment.apiBasePath, accessToken: environment.azure.token}),
    },
    {
        provide: HTTP_INTERCEPTORS,
        useClass: MsalInterceptor,
        multi: true,
    },
    {
        provide: MSAL_INSTANCE,
        useFactory: MSALInstanceFactory,
    },
    {
        provide: MSAL_INTERCEPTOR_CONFIG,
        useFactory: MSALInterceptorConfigFactory,
    },
    MsalService,
    MsalBroadcastService,
    provideAppInitializer(async () => inject(SecurityService).init()),
]);
